import Axios from "../../axios-interceptor";
import { ordersApiConstants } from "../../constants/AdminApiConstants";

export async function searchOrder(data) {
  return Axios.put(ordersApiConstants.SEARCH_ORDERS, data, {params: {page: 1, size: 10}});
}
